import echarts from 'echarts'

 
export default {
    show: function (id, optionType, param) {
        try {
            if (!param) return false;
            var optionData = (this.options[optionType])(param);
            this.chart = echarts.init(document.getElementById(id));
            this.chart.clear();
            this.chart.setOption(optionData);
            this.chart.resize({height:'444px'});
        } catch (err) {
            console.log(err)
        }
    },
    options:{
        //仪表盘 https://www.echartsjs.com/examples/zh/editor.html?c=gauge
        gauge:function (param) {
            if (!param.hasOwnProperty('title')) return false;
            var title = param.title;
            var name = param.name;
            var data = param.data;
            return {
                'title' : {
                    'text' : title,//'今日KPI'
                },
                'tooltip' : {
                    'formatter' : '{a} <br/>{b} : {c}%'
                },
                'toolbox' : {
                    'feature' : {
                        'saveAsImage' : {},
                    },
                },
                'series' : {
                    'name' : name,//'kpi进度',
                    'type' : 'gauge',
                    'detail' : {
                        'formatter' : '{value}%'
                    },
                    'data' : [
                        data
                        //{'value': 80, 'name': '完成率'},
                    ],
                },
            };
        },
        //曲线图 https://www.echartsjs.com/examples/zh/editor.html?c=line-smooth
        linesmooth:function (param) {
            if (!param.hasOwnProperty('title')) return false;
            var title = param.title;
            var x_axis = param.x_axis;
            var y_axis_list = param.y_axis_list;

            var series_data = [];
            for (var i=0; i<y_axis_list.length; i++) {
                series_data[i] = {
                    data : y_axis_list[i],
                    type : 'line',
                    smooth : true,
                }
            }
            
            return {
                title : {
                    text : title,//新增客户
                },
                xAxis : {
                    type : 'category',
                    data : x_axis,//['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                },
                yAxis : {
                    type : 'value',
                },
                series : series_data,
                // series : [
                //    {
                //        data : [820, 932, 901, 934, 1290, 1330, 1320],
                //        type : 'line',
                //        smooth : true,
                //    },
                // ],
            }
        },
        //曲线图（多条） https://www.echartsjs.com/examples/zh/editor.html?c=line-stack
        linesmooth_n:function (param) {
            return {
                title: {
                    text: param.title
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: param.legend,//['邮件营销','联盟广告','视频广告','直接访问','搜索引擎']
                },
                grid: {
                    left: '2%',
                    right: '2%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: param.X.arr,//['周一','周二','周三','周四','周五','周六','周日']
                },
                yAxis: {
                    type: 'value'
                },
                series:param.Y.arr,
            };
            
        },
        //柱状图 https://www.echartsjs.com/examples/zh/editor.html?c=bar-tick-align
        bartickalign:function (param) {
            return {
                title : {
                    text : param.title,//'今日KPI'
                },
                color: ['#3398DB'],
                tooltip : {
                    trigger: 'axis',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                        type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '2%',
                    right: '3%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis : [
                    {
                        type : 'category',
                        data : param.X.arr,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLabel: {
                            interval:0,  //设置这里
                            margin: 10,
                            rotate: 40,
                        }
                    },
                ],
                // xAxis:xAxis,
                yAxis : [
                    {
                        type : 'value'
                    }
                ],
                series : [
                    {
                        name:param.Y.name,
                        type:'bar',
                        barWidth: '50%',
                        data:param.Y.arr
                    },
                ],

                // series : series,
            };
        },
        //饼图，百分比  https://www.echartsjs.com/examples/zh/editor.html?c=pie-custom
        piecustom:function (param) {
            if (!param.hasOwnProperty('title')) return false;

            var title = param.title;
            var title_desc = param.title_desc;
            var x_axis = param.x_axis;
            var y_axis = param.y_axis;
            var options = {
                title : {
                    text: title,
                    subtext: title_desc,
                    x:'center'
                },
                grid: {
                    left: '10%',
                    right: '1%',
                    bottom: '3%',
                    containLabel: true
                },
                tooltip : {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: x_axis,
                },
                series : [
                    {
                        name: title,
                        type: 'pie',
                        radius : '55%',
                        center: ['50%', '60%'],
                        data:y_axis,
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            options.color = this._colors(param.x_axis.length);

            return options;
        },
        _colors:function(length){
            var arr = [
                '#FFA07A', '#BC8F8F', '#FF6A6A', '#D2B48C',
                '#808000','#DAA520','#D2691E','#228B22','#6495ED',
            ];
            arr = this.shuffle(arr);
            return arr.slice(0,length)
        },
        shuffle:function(arr){
            var newArr = [];
            for(var i=0; i<arr.length; i++){
                    var index = Math.floor(Math.random()*arr.length);//随机下标
                        newArr.push(arr[index]);//将随机出的元素，存放新数组newArr中去
                        arr.splice(index,1);//    将随机出的元素在arr中删除            
            }
            //arr中删除随机出的元素,arr.length-1,同时i++,导致循环不会10次,会是5次.最后得到newArr中只有一半的随机数字,arr中剩下另一半. 将其合并到一起,得到res
            var res =[...newArr,...arr];
            return res;
        },
    }
}


// WEBPACK FOOTER //
// ./src/library/echarts/echarts.js